/*-----------------------------------------------
 *
 *検索リセット
 *
 *-----------------------------------------------*/
function resetSearch() {
    $(".sectioning02").removeClass("active").slideUp(300);
  $('html, body').animate({
    scrollTop: $('#factory-search').offset().top - 80
  }, 500);

  $('#codeInput [name=search]').val('');
}

/*-----------------------------------------------
 *
 *InputのEnterキーで検索
 *
 *-----------------------------------------------*/
$('#searchInput').on('keydown', function(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
    seachFactory();
  } 
});

/*-----------------------------------------------
 *
 *生産工場を検索
 *
 *-----------------------------------------------*/
function seachFactory(){
  var _val = $('#codeInput [name=search]').val();

  const validCodes = [
    "H43", "H41", "N43", "N41", "N61", "N62", "N72", "N71", "N81", "N82", "N83", "N84", "N85", "N86", "N87", "N88",
    "N74", "N75", "N92", "U72", "U71", "S81", "S82", "S83", "S84", "S85", "S86", "S87", "S88", "E61", "E62", "E92",
    "E95", "G95", "R46", "N46", "S89", "N89", "S78", "N78", "H61", "H62", "H72", "H71", "H81", "H82", "H83", "H84",
    "H85", "H86", "H87", "H88", "H89", "H78", "H92", "Q62", "H42", "A62", "M21", "K31"
  ];

  const _valUpper = _val.toUpperCase();

  if (!validCodes.includes(_valUpper)) {
    $(".txHighlight01").addClass("on");
    return;
  } else {
    $(".txHighlight01").removeClass("on");
    // すべての.sectioning02をスライドアップして非表示
    $(".sectioning02").removeClass("active").slideUp(300);
    // 該当する.sectioning02のみスライドダウンして表示
    $("." + _val.toLowerCase() + ".sectioning02").addClass("active").slideDown(300, function() {
      // スクロールして表示された要素まで移動
      $('html, body').animate({
      scrollTop: $(this).offset().top - 80
      }, 500);
    });
  }
}